import React from 'react';
import style from '../styles.module.css';
import { CustomButton } from './CustomButton';

export const TabSelector = ({
  containerClassName = '',
  tabClassName = '',
  tabList = [],
  onTabSelect,
  selectedTabValue = '',
  selectedTabStyle = {},
  unselectedTabStyle = {},
  highlightBarStyle = {},
  tabContentStyle = {},
  labelStyle = {},
}) => {
  return (
    <div className={containerClassName || style.tabContainer}>
      {tabList.map(({ value, label }) => {
        const buttonStyle =
          selectedTabValue === value ? selectedTabStyle : unselectedTabStyle;
        const barStyle = { ...highlightBarStyle };

        if (selectedTabValue !== value) {
          barStyle.backgroundColor = 'transparent';
        }

        return (
          <CustomButton
            style={buttonStyle}
            key={value}
            className={tabClassName}
            onClick={() => {
              if (onTabSelect) {
                onTabSelect({ value, label });
              }
            }}
          >
            <div style={tabContentStyle}>
              <div style={labelStyle}>{label}</div>
              <div style={barStyle} />
            </div>
          </CustomButton>
        );
      })}
    </div>
  );
};
